<button mat-icon-button type="button" class="three-dots-btn" [matMenuTriggerFor]="menu">
	<mat-icon class="btn pointer" svgIcon="three_dots"></mat-icon>
</button>

<mat-menu #menu="matMenu" class="three-dots-menu" xPosition="before">
	@for (group of visibleGroups; track $index; let last = $last) {
		@for (option of group; track option.action) {
			<button mat-menu-item type="button" class="three-dots-option"
				[class.warn]="option.action === threeDotsActionsEnum.DELETE" (click)="performAction(option)">
				<mat-icon [svgIcon]="option.icon"></mat-icon>
				<span>{{option.name | translateWithKeys}}</span>
			</button>
		}
		@if (!last) {
			<div class="three-dots-divider" role="separator"></div>
		}
	}
</mat-menu>
